import { render } from "./InvestasiDetail.vue?vue&type=template&id=29451f87"
import script from "./InvestasiDetail.vue?vue&type=script&lang=js"
export * from "./InvestasiDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__